export const MEASUREMENT: Record<string, string> = {
  totalLength: '총장',
  shoulderWidth: '어깨너비',
  chestWidth: '가슴너비',
  sleeveLength: '소매길이',
  waistWidth: '허리단면',
  hipWidth: '엉덩이단면',
  thighWidth: '허벅지단면',
  rise: '밑위',
  hemWidth: '밑단단면',
};

export const GENDER: Record<string, string> = {
  male: '남성',
  female: '여성',
};

export const CATEGORY: Record<string, string> = {
  tops: '상의',
  outwears: '아우터',
  pants: '바지',
  dresses: '원피스',
  skirts: '스커트',
};

export const FIT: Record<string, string> = {
  skinny: '스키니',
  slim: '슬림',
  regular: '레귤러',
  relaxed: '루즈',
  oversized: '오버',
};

export const SUBCATEGORY: Record<string, string> = {
  all: '전체',
  shortSleeves: '반소매 상의',
  longSleeves: '긴소매 상의',
  longOutwears: '롱 아우터',
  midiOutwears: '미디 아우터',
  shortOutwears: '숏 아우터',
  longPants: '긴바지',
  shorts: '반바지',
  miniSkirts: '미니 스커트',
  midiSkirts: '미디 스커트',
  longSkirts: '롱 스커트',
  miniDresses: '미니 원피스',
  midiDresses: '미디 원피스',
  maxiDresses: '맥시 원피스',
};

export const USERFIELDS: Record<string, string> = {
  email: '이메일',
  name: '코드네임',
  password: '비밀번호',
  gender: '성별',
  height: '키',
  weight: '몸무게',
  description: '체형',
  physical: '피지컬',
};
